import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2026 loafy.net</p>
    </footer>
  );
};

export default Footer;
